import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from "../views/errorPage/404";
import Home from "../views/home/index.vue";
import Zh from "../views/zh/index.vue";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/zh",
  },

  {
    path: "/zh",
    redirect: "/zh/home",
    component: Zh,
    children: [
      //首页
      {
        path: "home",
        name: "home",
        component: Home,
      },
      //教育产品
      {
        path: "product",
        name: "product",
        component: (resove) => require(["../views/product/index.vue"], resove),
        children: [
          {
            path: "/zh/productInfo",
            name: "productInfo",
            component: (resove) => require(["../views/product/productInfo.vue"], resove),
          }, {

            path: "/zh/productList",
            name: "productList",
            component: (resove) => require(["../views/product/productList.vue"], resove),
          }
        ]
      },
      //应用案例
      {
        path: "/zh/case",
        name: "case",
        component: (resove) => require(["../views/case/index.vue"], resove),
        children: [
          {
            path: "/zh/caseInfo",
            name: "caseInfo",
            component: (resove) => require(["../views/case/caseInfo.vue"], resove),
          }, {

            path: "/zh/caseList",
            name: "caseList",
            component: (resove) => require(["../views/case/caseList.vue"], resove),
          }
        ]

      },
      //配件
      {
        path: "/zh/parts",
        name: "parts",
        component: (resove) => require(["../views/parts/index.vue"], resove),
      },
      //配件详情
      {
        path: "/zh/partsInfo",
        name: "parts",
        component: (resove) => require(["../views/parts/partsInfo.vue"], resove),
      },
      //培训
      {
        path: "/zh/train",
        name: "train",
        component: (resove) => require(["../views/train/index.vue"], resove),
        children: [
          {
            path: "/zh/trainInfo",
            name: "trainInfo",
            component: (resove) => require(["../views/train/trainInfo.vue"], resove),
          }, {

            path: "/zh/trainList",
            name: "trainList",
            component: (resove) => require(["../views/train/trainList.vue"], resove),
          }
        ]
      },
      //售后服务

      {
        path: "/zh/service",
        name: "postSalesService",
        component: (resove) =>
          require(["../views/postSalesService/index.vue"], resove),
      },
      // 服务政策
      {
        path: "/zh/servicePolicy",
        name: "servicePolicy",
        component: (resove) =>
          require(["../views/servicePolicy/index.vue"], resove),
      },
      //关于安道
      {
        path: "about",
        name: "about",
        component: (resove) => require(["../views/about/index.vue"], resove),
        redirect: "/zh/about/who",
        children: [
          {
            path: "/zh/about/who",
            name: "aboutWho",
            component: (resove) =>
              require(["../views/about/childComp/Who/Who.vue"], resove),
          },
          {
            path: "/zh/about/news",
            name: "aboutNews",
            redirect: "/zh/about/news/newList",
            component: (resove) => require(["../views/about/childComp/news/index.vue"], resove),
            children: [
              {
                path: "/zh/about/news/newList",
                name: 'News',
                component: (resove) =>
                  require(["../views/about/childComp/news/News.vue"], resove),
              },
              {
                path: "/zh/about/news/newsInfo",
                name: "newsInfo",
                component: (resove) =>
                  require(["../views/about/childComp/news/NewDetail.vue"], resove),
              },
            ],
          },
          {
            path: "/zh/about/join",
            name: "aboutJoin",
            component: (resove) =>
              require(["../views/about/childComp/Join/Join.vue"], resove),
          },
          {
            path: "/zh/about/contact",
            name: "aboutContact",
            component: (resove) =>
              require(["../views/about/childComp/Contact.vue"], resove),
          },
        ],
      },

      //下载中心
      {
        path: "download",
        name: "download",
        component: (resove) => require(["../views/download/index.vue"], resove),
      },
      //下载中心
      {
        path: "downpage",
        name: "downpage",
        component: (resove) =>
          require(["../views/download/weixinToast.vue"], resove),
      },
    ],
  },
  { path: '*', redirect: '/' } // 捕获所有其他路径并重定向到根路径
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.afterEach((to, from, next) => {
  window, scrollTo(0, 0);
});
export default router;
